import React from 'react';
import { Box, Typography } from '@mui/material';

interface NewBadgeProps {
  children: React.ReactNode;
  offsetX?: number;
  offsetY?: number;
}

export const NewBadge: React.FC<NewBadgeProps> = ({
  children,
  offsetX = 0,
  offsetY = 0,
}) => (
  <Box
    className="badge"
    sx={{
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
    }}
  >
    <span />
    {children}

    <Box
      sx={{
        position: 'absolute',
        top: offsetY,
        right: offsetX,
        transform: 'translate(50%, -50%)',
        backgroundColor: 'error.main',
        color: '#fff',
        borderRadius: '999px',
        padding: '3px',
        fontSize: 7,
        fontWeight: 600,
        lineHeight: 1,
        pointerEvents: 'none',
        animation: 'pulse 1.6s ease-in-out infinite',
        '@keyframes pulse': {
          '0%': {
            transform: 'translate(50%, -50%) scale(1)',
            opacity: 1,
          },
          '50%': {
            transform: 'translate(50%, -50%) scale(1.15)',
            opacity: 0.75,
          },
          '100%': {
            transform: 'translate(50%, -50%) scale(1)',
            opacity: 1,
          },
        },
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: 7,
          fontWeight: 400,
          letterSpacing: 0.4,
          color: '#fff',
        }}
      >
        NEW
      </Typography>
    </Box>
  </Box>
);
